import React from 'react';
import Highcharts from 'highcharts';

class QrCodeBarChart extends React.Component {
  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
  }

  componentDidMount() {
    const { data, title } = this.props;

    const categories = data.map(d => d.name);
    const values = data.map(d => d.count);

    Highcharts.chart(this.chartRef.current, {
      chart: { type: 'bar' },
      title: { text: title || 'Top QR Codes' },
      credits: { enabled: false },
      xAxis: {
        categories: categories,
        title: { text: null }
      },
      yAxis: {
        title: { text: 'Scans' },
        allowDecimals: false
      },
      series: [{
        name: 'Scans',
        data: values,
        color: '#43AC6A'
      }],
      legend: { enabled: false },
      tooltip: {
        pointFormat: '<b>{point.y}</b> scans'
      }
    });
  }

  render() {
    return <div ref={this.chartRef} style={{ width: '100%', minHeight: '400px' }} />;
  }
}

export default QrCodeBarChart;
